import classNames from 'classnames';
import styles from "./Button.module.css";
import type { DkVariantDark, DkVariantDarkOutline, DkVariantRed } from "src/lib/types/dk/DkVariants";

//#region [Props]
type ButtonProps = {
    text: string;
    /* The following are for filmweb. Will not be used on kinoDk */
    inverse?: boolean;
    disabled?: boolean;
    icon?: React.ReactNode;
    className?: string;
    isOutline?: boolean;
    title?: string;
    isLarge?: boolean;
    borderStyle?: "round" | "square" | "roundedSquare";
    iconLocation?: "front" | "back";
ref?: React.Ref<HTMLButtonElement>;

	/* Kinodk */
	dkVariant?: DkVariantDark | DkVariantDarkOutline | DkVariantRed;
	/* Filmweb */
	fwVariant?: "outlineGradient1";
} & React.HTMLAttributes<HTMLButtonElement>;

//#endregion




//#region [Component]
export default function Button({
	onClick,
	text,
	inverse = false,
	disabled = false,
	icon,
	className,
	isOutline = false,
	title,
	isLarge = false,
	borderStyle = "round",
	iconLocation = "front",
	dkVariant,
	fwVariant,
	ref,
	...rest
}: ButtonProps) {
	const buttonStyles = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ? {
		"themedk": true,
		[styles.ThemeDk]: true,
		[styles.Variant_Dark]: dkVariant === "dark",
		[styles.Variant_DarkOutline]: dkVariant === "darkOutline",
		[styles.Variant_Red]: dkVariant === "red",
		[styles.outline]: dkVariant === "darkOutline",
		[styles.square]: borderStyle === 'square',
		[styles.roundedSquare]: borderStyle === "roundedSquare",

    } : {
        "themefw": true,
        [styles.ThemeFw]: true,
        [styles.square]: borderStyle === 'square',
		[styles.roundedSquare]: borderStyle === "roundedSquare",
        [styles.inverse]: inverse,
        [styles.large]: isLarge,
        [styles.outline]: isOutline,
        [styles.iconBack]: iconLocation === "back",
        [styles.OutlineGradient1]: fwVariant === "outlineGradient1"
    }

	return <button
		ref={ref}
		onClick={onClick}
		disabled={disabled}
		className={classNames(className, styles.CoreButton, buttonStyles)}
		title={title}
		{...rest}
	>
		{iconLocation === "front" && icon}
		{text}
		{iconLocation === "back" && icon}
	</button>;
}
//#endregion